<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header :showGoBack="true" />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '12%', paddingBottom: '20px'}"
    >
      <h1 :style="{marginBottom: '30px'}">Sign up!</h1>
      <Input
        :leftIcon="UserSvg"
        :placeholder="'Enter your name'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="MailSvg"
        :placeholder="'Enter your email'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="KeySvg"
        :placeholder="'Enter your password'"
        :rightIcon="EyeOffSvg"
        :rightIconClickable="true"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="KeySvg"
        :rightIcon="EyeOffSvg"
        :rightIconClickable="true"
        :placeholder="'Enter your password'"
        :containerStyle="{marginBottom: '14px'}"
      />
      <Button
        :title="'Sign Up'"
        :containerStyle="{marginBottom: '14px'}"
        @click="() => $router.push(routes.VERIFY_YOUR_PHONE_NUMBER)"
      />
      <div
        :class="'row-center'"
        :style="{gap: '4px', marginBottom: '20px'}"
      >
        <span :class="'t16'">Already have an account?</span>
        <span
          :class="'t16 clickable'"
          :style="{color: 'var(--main-color)'}"
          @click="() => $router.push(routes.SIGN_IN)"
        >
          Sign in.</span
        >
      </div>
      <div
        :class="'row-center'"
        :style="{gap: '10px'}"
      >
        <div
          :style="{
            width: '100%',
            height: '40px',
            maxWidth: 'calc(100% / 3)',
            borderRadius: '8px',
            backgroundColor: '#FFD9C3',
          }"
          class="center"
        >
          <FaceBookSvg />
        </div>
        <div
          :style="{
            width: '100%',
            height: '40px',
            maxWidth: 'calc(100% / 3)',
            borderRadius: '8px',
            backgroundColor: '#FFD9C3',
          }"
          class="center"
        >
          <TwitterSvg />
        </div>
        <div
          :style="{
            width: '100%',
            height: '40px',
            maxWidth: 'calc(100% / 3)',
            borderRadius: '8px',
            backgroundColor: '#FFD9C3',
          }"
          class="center"
        >
          <GoogleSvg />
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
// hooks & routes
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

// components
import {Input} from '@/components';
import {Header} from '@/components';
import {Button} from '@/components';
import {Background} from '@/components';

// svg
import {KeySvg} from '@/assets/svg';
import {MailSvg} from '@/assets/svg';
import {UserSvg} from '@/assets/svg';
import {EyeOffSvg} from '@/assets/svg';
import {GoogleSvg} from '@/assets/svg';
import {TwitterSvg} from '@/assets/svg';
import {FaceBookSvg} from '@/assets/svg';

const opacity = useOpacity();
</script>
